<template>
    <tbody style="position: relative;"> <!-- some browsers won't keep scroll unless tbodys are added -->
        <tr>
            <td class="clickable-row" style="text-align: center;">
                <router-link class="simple-table-link" v-bind:to="txLink">
                    <div class="tx-table__cell tx-table__cell--align-center">{{ seqno }}</div>
                </router-link>
            </td>
            <td class="clickable-row">
                <router-link class="simple-table-link" v-bind:to="txLink">
                    <div class="tx-table__cell">
                        <ui-address v-bind:address="account"/>
                    </div>
                </router-link>
            </td>
            <td class="clickable-row">
                <router-link class="simple-table-link" v-bind:to="txLink">
                    <div class="tx-table__cell">{{ lt }}</div>
                </router-link>
            </td>
            <td class="clickable-row">
                <router-link class="simple-table-link" v-bind:to="txLink">
                    <div class="tx-table__cell">
                        <ui-address v-bind:address="hash" disabled />
                    </div>
                </router-link>
            </td>
            <td class="clickable-row" style="text-align: right;">
                <router-link class="simple-table-link" v-bind:to="txLink">
                    <div class="tx-table__cell tx-table__cell--align-right">{{ exitCode }}</div>
                </router-link>
            </td>
        </tr>
    </tbody>
</template>

<script>
export default {
    props: {
        seqno: Number,
        hash: String,
        account: String,
        exitCode: Number,
        lt: String,
    },

    computed: {
        txLink() {
            return {
                name: 'tx',
                params: { hash: this.hash },
            };
        },
    },
};
</script>
